import React from "react";
import { Navigate } from "react-router-dom";

import ServiceProviderPortalMismatchGate from "../components/customer/ServiceProviderPortalMismatchGate";
import { isServiceProviderPortalHost } from "../components/auth/postLoginNavigation";
import { isServiceProviderPortalRole } from "../components/helpers/constants";
import { decryptPayload } from "../components/helpers/utils";

const RoleProtectedRoute = ({ children, accessEntity, isIOS = null }) => {
  const allowedRoles = Array.isArray(accessEntity)
    ? accessEntity
    : accessEntity
      ? [accessEntity]
      : [];
  const currentRole =
    decryptPayload(localStorage.getItem("roles")) ||
    localStorage.getItem("activeRole");

  if (allowedRoles.includes(currentRole)) {
    return <>{children}</>;
  }

  // Leftover SP session on the consumer host (common after closing the
  // consumer-login → servicer redirect). Offer a portal choice instead of 404.
  if (
    isServiceProviderPortalRole(currentRole) &&
    !isServiceProviderPortalHost()
  ) {
    return <ServiceProviderPortalMismatchGate />;
  }

  return <Navigate to={"/404"} state={{ removeToken: true }} />;
};

export default RoleProtectedRoute;
